import api from '@/api/exchanges';


const createExchangeType = (context, payload) => new Promise(((resolve, reject) => {
  api.createExchangeType(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const updateExchangeType = (context, payload) => new Promise(((resolve, reject) => {
  api.updateExchangeType(payload.id, payload.data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getExchangeTypes = (context, payload) => new Promise(((resolve, reject) => {
  api.fetchExchangeTypes(payload)
    .then((response) => {
      context.commit('SET_EXCHANGE_TYPES', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const makeExchange = (context, payload) => new Promise(((resolve, reject) => {
  api.makeExchange(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getOpenExchanges = context => new Promise(((resolve, reject) => {
  api.fetchOpenExchanges()
    .then((response) => {
      context.commit('SET_OPEN_EXCHANGES', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getExchanges = (context, id) => new Promise(((resolve, reject) => {
  api.fetchExchanges(id)
    .then((response) => {
      context.commit('SET_EXCHANGES', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const performExchange = (context, exchangeId) => new Promise(((resolve, reject) => {
  api.performExchange(exchangeId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const deleteExchangeType = (context, exchangeId) => new Promise(((resolve, reject) => {
  api.deleteExchangeType(exchangeId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));


export default {
  createExchangeType,
  updateExchangeType,
  makeExchange,
  getExchangeTypes,
  getOpenExchanges,
  getExchanges,
  performExchange,
  deleteExchangeType,
};

